export const ID64 = () => {
    return (
        <div className="section__tab" id="kharakteristika_konfiguratsii" >
            <div className="about-card__title">
                Характеристика конфигурации
            </div>
            <p>
                Программный продукт <b>1С-Рейтинг: Алкомониторинг</b>&nbsp;предназначен&nbsp;для автоматизации
                деятельности предприятий, занимающихся оптовой и розничной торговлей алкогольной и табачной продукцией,
                является дополнением к конфигурации <b>Бухгалтерия для Казахстана</b>.
            </p>
            <p>
                Позволяет автоматизировать:
            </p>
            <ul>
                <li>учет товаров в разрезе пин-кодов, а также адресов и лицензий налогоплательщиков</li>
                <li>формирование СНТ на основании первичных бухгалтерских документов по движениям алкогольной и табачной
                    продукции
                </li>
                <li>формирование деклараций производства и оборота этилового спирта и алкогольной продукции на основании
                    данных бухгалтерского учета
                </li>
                <li>интеграцию с ИС ЭСФ (СНТ, ЭСФ, ведение учета на ВС).</li>
            </ul>
            <p>
                Программный продукт позволяет формировать регламентированные отчеты по учетным данным:
            </p>
            <ul>
                <li>декларацию по производству и обороту этилового спирта и/или виноматериала</li>
                <li>декларацию по производству и обороту алкогольной продукции</li>
                <li>декларацию по обороту алкогольной продукции.</li>
            </ul>
            <p>
                В документы оборота алкогольной продукции вносятся дополнительные сведения, которые требуются для
                формирования указанных деклараций. Заполненные декларации можно выгрузить в формате Excel,&nbsp; с целью
                последующего предоставления их налоговым органам в приложении ИСНА.
            </p>
            <p>
                Декларации формируются в соответствии с&nbsp;
            </p>
            <p>
            </p>
            <ul>
                <li>приказом министра финансов Республики Казахстан №461 от 17.09.2010 «Об утверждении Правил
                    предоставления деклараций производства и оборота этилового спирта и алкогольной продукции»
                </li>
                <li>приказом министра финансов Республики Казахстан № 88 от 13.02.2015 года «Об утверждении Правил
                    предоставления деклараций по производству и обороту этилового спирта и алкогольной продукции»
                </li>
            </ul>
            <p>
            </p>
            <br/>
        </div>
    )
}